import { EventDetails } from 'sections/Events/components/EventDetails/EventDetails.types';

export const eventDetailsData: EventDetails[] = [
  {
    id: 1,
    img: '/images/pages/Events/icon-calendar.svg',
    text: '19 February 2026',
  },
  {
    id: 2,
    img: '/images/pages/Events/icon-location.svg',
    text: 'Online meeting',
  },
];